export default "__VITE_ASSET__c1bba0a1__"